import { useState, useEffect } from "react";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled ? "bg-white shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 h-16 flex items-center justify-between">
        <a href="/" className="flex items-center gap-2">
          <img
            src="https://static.readdy.ai/image/f3ca0b85088a2ff6b3b1c7af1abe445d/33d5a3400b39a85f6a3e281b88da1a84.png"
            alt="Massagistas Online - Massagistas em Curitiba"
            className="h-9 w-auto object-contain"
          />
        </a>

        <nav className="hidden md:flex items-center gap-8">
          <a href="#beneficios" className={`text-sm font-medium transition-colors hover:text-rose-400 ${scrolled ? "text-stone-700" : "text-white"}`}>
            Benefícios
          </a>
          <a href="#bairros" className={`text-sm font-medium transition-colors hover:text-rose-400 ${scrolled ? "text-stone-700" : "text-white"}`}>
            Por Bairro
          </a>
          <a href="#sobre" className={`text-sm font-medium transition-colors hover:text-rose-400 ${scrolled ? "text-stone-700" : "text-white"}`}>
            Sobre
          </a>
          <a
            href="https://classivip.com/massagistas"
            target="_blank"
            rel="nofollow noopener"
            className="bg-rose-400 hover:bg-rose-500 text-white text-sm font-semibold px-5 py-2 rounded-full transition-colors whitespace-nowrap"
          >
            Ver Massagistas
          </a>
        </nav>

        <button
          className="md:hidden flex items-center justify-center w-9 h-9"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menu"
        >
          <i className={`ri-${menuOpen ? "close" : "menu"}-line text-2xl ${scrolled ? "text-stone-700" : "text-white"}`}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-white shadow-lg px-6 py-4 flex flex-col gap-4">
          <a href="#beneficios" className="text-stone-700 text-sm font-medium" onClick={() => setMenuOpen(false)}>Benefícios</a>
          <a href="#bairros" className="text-stone-700 text-sm font-medium" onClick={() => setMenuOpen(false)}>Por Bairro</a>
          <a href="#sobre" className="text-stone-700 text-sm font-medium" onClick={() => setMenuOpen(false)}>Sobre</a>
          <a
            href="https://classivip.com/massagistas"
            target="_blank"
            rel="nofollow noopener"
            className="bg-rose-400 text-white text-sm font-semibold px-5 py-2 rounded-full text-center whitespace-nowrap"
          >
            Ver Massagistas
          </a>
        </div>
      )}
    </header>
  );
}
